import { memo, useEffect, useState, useRef } from "react"
import ProductList from "@/components/product/list"
import ProductService from "@/services/product"
import { Box, Flex, Stack, Text, VStack } from "@chakra-ui/react"
import { useNavigate, useParams } from "react-router";
import { HStack, Input, Center, AspectRatio, Button, Image, Table, Container, Wrap, Float, Drawer, CloseButton, Skeleton, SkeletonText, Separator } from "@chakra-ui/react"
import { LuSearch, LuShoppingCart, LuMessageCircle } from "react-icons/lu"
import { Heading } from "@chakra-ui/react"



import { Field } from "@/components/ui/field"
import Slider from "react-slick";
import { useCart } from "contexts/cart"
import { formatCurrency } from "@/utilities/number"
import { StepperInput } from "@/components/ui/stepper-input"
import { useApp } from "contexts/app"
import { useAuth } from "contexts/auth"

import _ from "lodash"
import { useStore } from "contexts/store";
import BottomSheet from "components/bottom-sheet"
import { useForm } from "react-hook-form"
import CtvService from "services/ctv"
const service = new CtvService();
const Withdraw = ({ open, amount, onOpenChange }) => {

    const { user } = useAuth();
    const { showToast } = useApp();

    const { copyText } = useApp();
    const { store } = useStore();
    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        watch,
        clearErrors,
    } = useForm({
        defaultValues: {
            amount: Number(amount || 0),
        }
    })

    const currentAmount = Number(amount || 0);
    const withdrawableAmount = Math.max(0, Math.floor(currentAmount));
    const amountInput = watch("amount");

    useEffect(() => {
        if (open) {
            setValue("amount", withdrawableAmount);
            clearErrors("amount");
        }
    }, [open, withdrawableAmount, setValue, clearErrors])

    const onSubmit = handleSubmit(async (data) => {
        const amountValue = Math.round(Number(data.amount || 0));
        if (amountValue <= 0) {
            showToast({ type: "error", description: "Số tiền rút không hợp lệ" });
            return;
        }
        if (amountValue < 1000) {
            showToast({ type: "error", description: "Số tiền rút tối thiểu là 1.000đ" });
            return;
        }
        if (amountValue > withdrawableAmount) {
            showToast({ type: "error", description: "Số tiền rút không được lớn hơn số dư hoa hồng" });
            return;
        }
        await service.withdrawRequest({ amount: amountValue });
        showToast("Đã gửi yêu cầu rút tiền. Chúng tôi sẽ xử lý yêu cầu của bạn sớm nhất có thể.");
        onOpenChange(false)
    })



    return (
        <div>
            <BottomSheet open={open} onOpenChange={(e) => onOpenChange(e.open)} title="Rút tiền hoa hồng">
                <VStack>


                    <form onSubmit={onSubmit}  >
                        <Field
                            label="Số tiền bạn muốn rút"
                            invalid={!!errors.amount}
                            errorText={errors.amount?.message}
                        >
                            <Input
                                type="number"
                                min={0}
                                step={1000}
                                {...register("amount", {
                                    required: "Bạn phải nhập số tiền",
                                    validate: (value) => {
                                        const amountValue = Number(value || 0);
                                        if (!Number.isFinite(amountValue)) {
                                            return "Số tiền rút không hợp lệ";
                                        }
                                        if (amountValue <= 0) {
                                            return "Số tiền rút phải lớn hơn 0";
                                        }
                                        if (amountValue < 1000) {
                                            return "Số tiền rút tối thiểu là 1.000đ";
                                        }
                                        if (amountValue > withdrawableAmount) {
                                            return "Số tiền rút không được lớn hơn số dư hoa hồng";
                                        }
                                        return true;
                                    }
                                })}
                            />
                        </Field>
                        <Text fontSize="sm" color="fg.muted">
                            Có thể rút tối đa: {formatCurrency(withdrawableAmount)}
                        </Text>
                        {Number(amountInput || 0) > withdrawableAmount && (
                            <Text fontSize="sm" color="red.500">
                                Số tiền nhập đang lớn hơn số dư có thể rút.
                            </Text>
                        )}
                    </form>
                    <Center>
                        <Button onClick={e => handleSubmit(onSubmit)()}>Gửi yêu cầu</Button>
                    </Center>
                </VStack>
            </BottomSheet>



        </div>
    )
}

export default memo(Withdraw)